// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"PruebaTable_spinnerContainer__qiYsd","botonAdd":"PruebaTable_botonAdd__UFuKD"};